export default function(sourceName: string): string {
  return sourceName ? sourceName.replace('english_wiki', 'wiki').replace(/[^a-zA-Z0-9 :]/g, ' ') : '';
}
